import "./App.css";

import Dictionary from "./dictionary/Dictionary";

function App() {
  return (
    <div className="App">
      <div className="container text-center">
        <section className="title">
          <h1>DEFINE ME</h1>
          <p>
            Do you need a word defining? Or are you just curious about a word?
            We got you!
          </p>
        </section>
        <Dictionary />
      </div>
      <footer className="text-center">
        <small>
          Coded by{" "}
          <a
            href="https://github.com/EllyHowell"
            target="_blank"
            rel="noreferrer"
          >
            Elly Howell
          </a>{" "}
          and hosted on{" "}
          <a href="https://www.netlify.com/" target="_blank" rel="noreferrer">
            Netlify
          </a>
        </small>
      </footer>
    </div>
  );
}

export default App;
